import { gsap, ScrollTrigger } from "../layout";

document.addEventListener('DOMContentLoaded', () => {
    
})

window.addEventListener('resize', () => {
    
})